import { Injectable } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
import { BaseCommand } from '../base/base-command'

@Injectable({ providedIn: 'root' })
export class CommandResultService {
  constructor(private snackBar: MatSnackBar) {}

  handleResult(command: BaseCommand<any, any>): void {
    const result = command.lastResult
    if (!result) return

    if (result.success) {
      this.snackBar.open(result.message || 'Operation successful', '', {
        duration: 3000,
        panelClass: ['success-snackbar', 'top-margin-snackbar'],
        verticalPosition: 'top',
      })
    } else {
      this.snackBar.open(result.message || 'Operation failed', '', {
        duration: 5000,
        panelClass: ['error-snackbar', 'top-margin-snackbar'],
        verticalPosition: 'top',
      })
    }
  }

  handleError(error: unknown): void {
    this.snackBar.open(
      error instanceof Error ? error.message : 'An unexpected error occurred',
      '',
      {
        duration: 5000,
        panelClass: ['error-snackbar', 'top-margin-snackbar'],
        verticalPosition: 'top',
      },
    )
  }
}
